var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_822_1982)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_822_1982",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H48V48H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_822_1982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99413 27.0939C9.77472 32.947 13.7574 38.999 22.6485 43.8627C23.4902 44.3231 24.5099 44.3231 25.3516 43.8627C39.4352 36.1585 41.2031 25.4729 41.4114 17.319C41.4461 15.9619 40.56 14.757 39.26 14.3658C36.8527 13.6415 33.095 11.9226 31.4225 8.03089C30.9509 6.93336 29.8616 6.22986 28.6669 6.22986H19.3331C18.1384 6.22986 17.0492 6.93336 16.5775 8.03089C14.905 11.9226 11.1473 13.6415 8.74 14.3658C7.44007 14.757 6.55394 15.9619 6.58863 17.319C6.6356 19.1572 6.76179 21.124 7.09057 23.1564",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1414 10.4649C30.5768 13.8049 33.6395 16.3281 37.7656 17.5695C37.8467 17.5939 37.9022 17.6634 37.9003 17.7383C37.8217 20.8138 37.4905 24.8475 35.6106 28.7732",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8125 32.7163H20.6506C19.8339 32.7163 19.1719 32.0542 19.1719 31.2376V24.5388C19.1719 23.7221 19.8339 23.0601 20.6506 23.0601H27.3494C28.1661 23.0601 28.8281 23.7221 28.8281 24.5388V31.2376C28.8281 32.0542 28.1661 32.7163 27.3494 32.7163",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0105 22.9033V20.7111C21.0105 19.0599 22.349 17.7215 24.0002 17.7215C25.6513 17.7215 26.9898 19.0599 26.9898 20.7111V22.9033",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 26.7163V29.2476",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7371 40.0812V45.8845H44.3438",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8419 47.2969C45.0383 47.2969 44.3867 46.6454 44.3867 45.8417C44.3867 45.0381 45.0383 44.3866 45.8419 44.3866C46.6455 44.3866 47.297 45.0381 47.297 45.8417C47.297 46.6454 46.6455 47.2969 45.8419 47.2969Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6406 39.6411H45.7969V34.0345",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2968 32.5365C47.2968 33.3402 46.6454 33.9917 45.8418 33.9917C45.038 33.9917 44.3865 33.3402 44.3865 32.5365C44.3865 31.7329 45.038 31.0814 45.8418 31.0814C46.6454 31.0814 47.2968 31.7329 47.2968 32.5365Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01975 35.7189C8.01975 36.5225 7.36819 37.1741 6.56456 37.1741C5.76084 37.1741 5.10938 36.5225 5.10938 35.7189C5.10938 34.9153 5.76084 34.2637 6.56456 34.2637C7.36819 34.2637 8.01975 34.9153 8.01975 35.7189Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6135 10.2189C3.6135 11.0225 2.96194 11.6741 2.15831 11.6741C1.35459 11.6741 0.703125 11.0225 0.703125 10.2189C0.703125 9.41526 1.35459 8.7637 2.15831 8.7637C2.96194 8.7637 3.6135 9.41526 3.6135 10.2189Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39475 4.03138C5.39475 4.83501 4.74319 5.48657 3.93956 5.48657C3.13584 5.48657 2.48438 4.83501 2.48438 4.03138C2.48438 3.22776 3.13584 2.5762 3.93956 2.5762C4.74319 2.5762 5.39475 3.22776 5.39475 4.03138Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2968 8.53651C47.2968 9.34023 46.6454 9.9917 45.8418 9.9917C45.038 9.9917 44.3865 9.34023 44.3865 8.53651C44.3865 7.73289 45.038 7.08142 45.8418 7.08142C46.6454 7.08142 47.2968 7.73289 47.2968 8.53651Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 2.15843C40.6406 2.96206 39.9891 3.61353 39.1855 3.61353C38.3818 3.61353 37.7302 2.96206 37.7302 2.15843C37.7302 1.35471 38.3818 0.703244 39.1855 0.703244C39.9891 0.703244 40.6406 1.35471 40.6406 2.15843Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1406 8.67188V3.60938",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9531 12.6094V8.67188H44.3906",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65627 44.3866C8.85264 44.3866 8.20117 45.0381 8.20117 45.8417C8.20117 46.6454 8.85264 47.2969 9.65627 47.2969C10.4599 47.2969 11.1114 46.6454 11.1114 45.8417C11.1114 45.0381 10.4599 44.3866 9.65627 44.3866Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15846 39.5116C1.35484 39.5116 0.703369 40.1631 0.703369 40.9667C0.703369 41.7704 1.35484 42.4219 2.15846 42.4219C2.96209 42.4219 3.61365 41.7704 3.61365 40.9667C3.61365 40.1631 2.96209 39.5116 2.15846 39.5116Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 35.4375V40.9219H3.70312",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 41.5313V44.3906",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 35.6719H8.20312",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1447 2.25218C15.1447 3.05581 14.4932 3.70728 13.6896 3.70728C12.8858 3.70728 12.2344 3.05581 12.2344 2.25218C12.2344 1.44846 12.8858 0.796994 13.6896 0.796994C14.4932 0.796994 15.1447 1.44846 15.1447 2.25218Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3281 2.34581H22.4062V6.1875",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76562 14.3906V4.07813H5.48438",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60938 10.1719H8.71875",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_822_1982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.7b177c35647e565ab5e659bc8f90a595.svg";
export { ForwardRef as ReactComponent };